import { useState, useEffect, useRef, useCallback } from 'react'
import api from '@api'
import { ApolloError } from 'apollo-boost'

export default function usePollImportStatus(id: string | null) {
  const [status, setStatus] = useState('')
  const [error, setError] = useState<ApolloError | null>(null)
  const [progress, setProgress] = useState<null | number>(null)
  const [total, setTotal] = useState(0)
  const [processed, setProcessed] = useState(0)
  const timeoutId = useRef<number | null>(null)

  const query = useCallback(() => {
    id &&
      api.booking.import
        .progress(id)
        .then(({ status, progress }) => {
          setStatus(status)
          if (progress.progress && progress.total) {
            setProgress(progress.progress / progress.total)
            setTotal(progress.total)
          }
          setProcessed(progress.progress)

          if (status === 'pending' || status === 'queued') {
            timeoutId.current = window.setTimeout(query, 500)
          } else if (status === 'failed') {
            setError(new Error('Oops, something went wrong...') as ApolloError)
          }
        })
        .catch((error) => setError(error))
  }, [id])

  useEffect(() => {
    query()
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current)
      }
    }
  }, [query])

  return {
    error,
    progress,
    total,
    processed,
    newStatus: status,
  }
}
